import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const NotebookIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 21.66 21.5",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 21.5),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "m7.23 20.75h-4.54a1.94 1.94 0 0 1 -1.94-1.94"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.3 8.1v-6.67a.68.68 0 0 0 -.19-.47.64.64 0 0 0 -.45-.2h-12.32a2.63 2.63 0 0 0 -2.59 2.67v15.37a1.98 1.98 0 0 1 1.94-2h5.19"
    }), /*#__PURE__*/jsx("path", {
      d: "m20.21 13.51-6.59 6.6-3.24.64.65-3.24 6.6-6.6a1.83 1.83 0 0 1 2.58 0v.02a1.83 1.83 0 0 1 0 2.58z"
    })]
  });
};

export { NotebookIcon };
//# sourceMappingURL=notebook.simple.js.map
